import { environment as defaultEnv } from './environment.morava';

export const environment = {
    ...defaultEnv,
    production: true,
    protocol: 'https',
    host: 'api.dolnimorava.cz/eshop-api',
    basicAuthToken: 'bGlwbm86Wk1jRTY1RU9Wbm9xRktsTXBoU04=',
    mediaUrl: 'https://dolnimorava-images.s3.eu-central-1.amazonaws.com',
    debug: false,
};
